import AnalyzePerformanceNavHeader from "./AnalyzePerformanceNavHeader";
import "./AnalyzePerformanceNavHeader.scss";

export default AnalyzePerformanceNavHeader;